export const FETCH_USER_BEGIN = "FETCH_USER_BEGIN";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
